"use client";

import { motion, Variants } from "framer-motion";

interface ContactHeaderProps {
  title: string;
  intro: string;
  itemVariants?: Variants;
}

export function ContactHeader({ title, intro, itemVariants }: ContactHeaderProps) {
  return (
    <motion.div
      className="mb-10"
      variants={itemVariants}
    >
      <motion.h1
        className="text-4xl md:text-4xl font-bold mb-4 text-[#ff8855]"
      >
        {title}
      </motion.h1>
      <motion.p
        className="text-md md:text-lg text-white/80 max-w-2xl"
      >
        {intro}
      </motion.p>
    </motion.div>
  );
}